<div class="page-container no-scroll inner-padding h-100" [class.loading]="isLoading">
    <app-header [title]="headerTitle" [subtitle]="headerSubTitle" [back]="true" [backRoute]="backRoute"></app-header>

    <ui-banner variant="info" class="mobile-hide">
        @if (isUploadingViewOnly) {
            {{ 'document.newViewOnlyAccessibleTo' | translate }}
        } @else {
            {{
                'document.newTemplateAccessibleTo'
                    | translate: { type: ('document.acknowledgement' | translate).toLowerCase() }
            }}
        }
    </ui-banner>

    <app-bulk-file-uploader
        *ngIf="!isLoading"
        (filesAdded)="filesAdded($event)"
        [allowedTypes]="allowedFileTypes"
        (upload)="upload()"
        (reset)="reset()"
        (remove)="remove($event)"
        [uploadDescriptor]="uploadDescriptor"
        [status]="status"
        [allowMoreFiles]="allowMoreFiles()"
        [uploadables]="uploadables"
        [uploadableTemplate]="uploadableTemplate"
    >
    </app-bulk-file-uploader>
</div>

<!-- This template is passed to bulk file uploader for iteration -->
<!-- This template can expect to be passed an uploadable-->
<ng-template #uploadableTemplate let-uploadable let-idx="idx">
    <div class="uploadable">
        <div class="bulk-upload-header">
            <!-- This could be a component -->
            <div class="file-name">
                <mat-icon svgIcon="attach"></mat-icon>
                {{ uploadable.file.name }}
            </div>
            <ui-button
                *ngIf="uploadable.status === 'pending'"
                type="ghost"
                size="no-padding"
                (click)="remove(uploadable)"
            >
                <mat-icon svgIcon="close"></mat-icon>
                {{ 'remove' | translate }}
            </ui-button>
            <div class="upload-result uploading" *ngIf="uploadable.status === 'uploading'">
                <mat-icon class="running" svgIcon="loading"></mat-icon> {{ 'document.uploading' | translate }}
            </div>
            <div class="upload-result error" *ngIf="uploadable.status === 'failed'">
                <mat-icon svgIcon="error"></mat-icon>
                {{ 'document.uploadFailedPleaseReuploadAndTryAgain' | translate }}
            </div>
            <div class="upload-result" *ngIf="uploadable.status === 'complete'">
                <mat-icon svgIcon="check"></mat-icon> {{ 'document.uploaded' | translate }}
            </div>
        </div>
        <mat-form-field [class.margin-bottom-1]="uploadable.nameFormControl.invalid">
            <mat-label>{{ 'forms.company-document.documentName' | translate }}</mat-label>
            <input
                matInput
                [errorStateMatcher]="errorStateMatcher"
                type="text"
                required
                [name]="'company-document-name-' + idx"
                [formControl]="uploadable.nameFormControl"
            />
            <mat-error *ngIf="!uploadable.getUploadableName()">{{
                'document.aDocumentNameIsRequired' | translate
            }}</mat-error>
            <mat-error *ngIf="uploadable.duplicatesPersistedDocumentName">{{
                'document.companyDocumentSameNameError' | translate
            }}</mat-error>
            <mat-error *ngIf="uploadable.duplicatesLocalDocumentName && !uploadable.duplicatesPersistedDocumentName">{{
                'document.anotherDocumentSameNameError' | translate
            }}</mat-error>
        </mat-form-field>
        <ui-chips-autocomplete
            [disabled]="uploadable.status !== 'pending'"
            #tagAutocomplete
            label="{{ 'forms.company-document.tags' | translate }}"
            [allowAdditions]="true"
            placeholder="{{ 'forms.company-document.addATag' | translate }}"
            [autocompleteItems]="companyDocumentTags"
            (changes)="uploadable.addTagsFromChips($event)"
        ></ui-chips-autocomplete>
    </div>
</ng-template>
